import React from 'react';
import VoiceJourneyLoader from './VoiceJourney.styles';
import { Box, Typography } from '@mui/material';
import VoiceJourneyFooter from './Sections/VoiceJourneyFooter';

const VoiceJourney = ({ customDetails }) => {
    
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
      }}
    >
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '2rem',
          padding: '2rem'
        }}
      >
        <VoiceJourneyLoader />
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#514b82',
            fontWeight: 600,
            fontSize: '16px',
            textAlign: 'center',
            fontFamily: customDetails?.fontFamily,
          }}
        >
          Finvu AA is calling you, please wait...
        </Typography>
      </Box>
      <VoiceJourneyFooter customDetails={customDetails} />
    </Box>
  )
}

export default VoiceJourney